import classNames from 'classnames/bind';

import styles from './Footer.module.scss';
import images from '~/assets/images';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { ZaloIcon } from '../Icons/Icons';
import config from '~/config/config';
import { Link } from 'react-router-dom';

const cx = classNames.bind(styles);

function Footer() {
    const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 0) {
            window.requestAnimationFrame(scrollToTop);
            window.scrollTo(0, c - c / 8);
        }
    };

    const aboutScroll = () => {
        const t = document.querySelector('#about');
        if (window.matchMedia('(max-width: 768px)').matches) {
            t.scrollIntoView({ block: 'start', behavior: 'smooth' });
        } else {
            t.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
    };

    const educationScroll = () => {
        const edu = document.querySelector('#education');
        edu &&
            edu.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
    };

    const portfolioScroll = () => {
        const p = document.querySelector('#portfolio');
        p &&
            p.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
    };

    const blogScroll = () => {
        const b = document.querySelector('#blog');
        b &&
            b.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
    };

    return (
        <div className={cx('wrapper')}>
            <div className={cx('inner', 'grid', 'wide')}>
                <div className={cx('row')}>
                    <div className={cx('left', 'col', 'p-6', 't-12', 'm-12')}>
                        <div className={cx('logo')}>
                            <a href="/">
                                <img src={images.logo} alt="LogoImage" />
                            </a>
                        </div>
                        <div className={cx('des')}>
                            <p>
                                Chào mừng các bạn, quý anh chị đã ghé thăm trang cá nhân này của mình. Nếu có thắc mắc
                                hoặc hoặc góp ý thì quý anh/chị, các bạn có thể liên hệ mình qua Email. Cảm ơn rất nhiều
                                và chúc một ngày tốt lành!
                            </p>
                        </div>
                        <div className={cx('contact')}>
                            <a href="https://facebook.com/anh.buihtbk" target="blank" className={cx('facebook')}>
                                <div className={cx('background')}>
                                    <FaFacebookF className={cx('icon')} />
                                </div>
                            </a>
                            <a href="https://instagram.com/birdy.mr" target="blank" className={cx('instagram')}>
                                <div className={cx('background')}>
                                    <img
                                        src={images.instagram}
                                        alt="instagram"
                                        className={cx('icon', 'ins-color')}
                                        style={{ display: 'none', marginTop: '-3px' }}
                                    />
                                    <FaInstagram className={cx('icon', 'ins-trans')} />
                                </div>
                            </a>
                            <a href="https://linkedin.com/in/anh-buihtbk" target="blank" className={cx('linkedin')}>
                                <div className={cx('background')}>
                                    <FaLinkedinIn className={cx('icon')} />
                                </div>
                            </a>
                            <a href="https://zaloapp.com/qr/p/si2jhq54q3lx" target="blank">
                                <div className={cx('background', 'background-zalo')}>
                                    <ZaloIcon className={cx('zalo')} />
                                </div>
                            </a>
                            <div className={cx('qr-zalo')}>
                                <img src={images.zaloqr} alt="zaloImage" />
                            </div>
                        </div>
                    </div>
                    <div className={cx('right', 'col', 'p-6', 't-12', 'm-12')} style={{ display: 'flex' }}>
                        <div className={cx('right-nav', 'navigation')}>
                            <div className={cx('header')}>
                                <h2>Điều Hướng</h2>
                            </div>
                            <ul className={cx('content')}>
                                <Link to={config.routes.home} onClick={scrollToTop}>
                                    <li>Trang chủ</li>
                                </Link>
                                <Link to={config.routes.about} onClick={aboutScroll}>
                                    <li>Giới thiệu</li>
                                </Link>
                                <Link to={config.routes.education} onClick={educationScroll}>
                                    <li>Học vấn</li>
                                </Link>
                                <Link to={config.routes.portfolio} onClick={portfolioScroll}>
                                    <li>Sản phẩm</li>
                                </Link>
                                <Link to={config.routes.blog} onClick={blogScroll}>
                                    <li>Blog</li>
                                </Link>
                            </ul>
                        </div>
                        <div className={cx('right-product', 'navigation')}>
                            <div className={cx('header')}>
                                <h2>Sản phẩm</h2>
                            </div>
                            <ul className={cx('content')}>
                                <a target="_blank" href="https://w3band-anh.netlify.app" rel="noreferrer">
                                    <li>Band</li>
                                </a>
                                <a target="_blank" href="https://tiktok-anh.netlify.app" rel="noreferrer">
                                    <li>TikTok</li>
                                </a>
                                <a target="_blank" href="https://music-anh.netlify.app" rel="noreferrer">
                                    <li>Music App</li>
                                </a>
                                <a target="_blank" href="https://dashboard-anh.netlify.app" rel="noreferrer">
                                    <li>Admin Dashboard</li>
                                </a>
                                <a target="_blank" href="https://shopee-anh.netlify.app" rel="noreferrer">
                                    <li>Shopee</li>
                                </a>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;
